// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2s-C_","rootCenter":"LoadMoreObserver_rootCenter__1K84H","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2h6KN"};